import React, { useEffect, useState } from 'react';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { TextField } from 'src/components/new/inputs/TextField';

interface AddEditPriceSheetProps {
  open: boolean;
  initialName: string;
  title: string;
  onClose: () => void;
  onSuccess: (name: string) => void;
}

const AddEditPriceSheet: React.FC<AddEditPriceSheetProps> = ({ open, onClose, onSuccess, title, initialName }) => {
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  useEffect(() => {
    if (open) {
      setName(initialName);
    }
  }, [initialName, open]);

  const handleSubmit = () => {
    if (name === '') {
      setNameError('Name is required');
    } else {
      onSuccess(name);
      setName('');
    }
  };

  const handleClose = () => {
    onClose();
    setName('');
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} sx={{ minWidth: '27.5rem' }}>
        <ModalTitle small onClose={handleClose}>
          {title}
        </ModalTitle>
        <ModalContent small>
          <TextField
            required
            value={name}
            inputProps={{ maxLength: 80 }}
            name="sheetName"
            id="sheetName"
            onChange={(e) => setName(e.target.value)}
            error={nameError}
            label="Sheet Name"
          />
        </ModalContent>
        <ModalFooter onSubmit={handleSubmit} submitText="Apply" />
      </Modal>
    </>
  );
};

export default AddEditPriceSheet;
